import UserLayout from "../components/UserLayout";
import About from "../components/About";
const AboutPage = () => {
    return (
        <UserLayout>
            <About />
        </UserLayout>
    );
}

export default AboutPage;